import { useContext } from 'react';

import { CustomerContext } from '@funnels/contexts';
import { ClientCustomer } from '@funnels/types';

export function useCustomer(): ClientCustomer {
  return useContext(CustomerContext);
}
